const translations = {
  // Nav
  "nav.home": "Accueil",
  "nav.mission": "Mission",
  "nav.projects": "Projets",
  "nav.stories": "Histoires",
  "nav.volunteer": "Bénévolat",
  "nav.donate": "Faire un don",
  "nav.contact": "Contact",
  "nav.donateNow": "Faire un don",

  // Language bar
  "lang.managed": "Géré via le tableau de bord CMS Admin",

  // Hero
  "hero.badge": "Construire des ponts · Créer de l'espoir",
  "hero.title": "Autonomiser les communautés afghanes par l'éducation et les opportunités",
  "hero.subtitle": "La Fondation Canada Afghanistan connecte des Canadiens compatissants avec des communautés afghanes dans le besoin — finançant l'éducation, la santé et le développement durable depuis 2016.",
  "hero.cta.donate": "Soutenir notre mission",
  "hero.cta.learn": "Notre histoire",
  "hero.scroll": "Défiler",
  "hero.stats": "[{\"label\":\"Étudiants soutenus\",\"value\":\"2 500+\"},{\"label\":\"Projets actifs\",\"value\":\"15\"},{\"label\":\"Années d'impact\",\"value\":\"8\"},{\"label\":\"Bénévoles\",\"value\":\"340+\"}]",

  // Mission Preview
  "mission.tag": "Notre Mission",
  "mission.title": "Un pont entre deux nations, bâti sur la compassion",
  "mission.body1": "La Fondation Canada Afghanistan (CAF) est un organisme de bienfaisance canadien enregistré dédié à l'amélioration de la vie des Afghans grâce à des programmes ciblés en éducation, santé et développement communautaire.",
  "mission.body2": "Nous croyons que chaque enfant afghan mérite l'accès à l'éducation, chaque famille mérite de l'eau potable, et chaque communauté mérite la chance de prospérer — peu importe les conflits.",
  "mission.cta": "Lire notre mission complète",
  "mission.pillar.education": "Éducation",
  "mission.pillar.education.desc": "Financement d'écoles, de bourses et de formations professionnelles pour les jeunes et les femmes afghanes.",
  "mission.pillar.healthcare": "Santé",
  "mission.pillar.healthcare.desc": "Déploiement de cliniques mobiles et soutien aux professionnels de santé dans les régions mal desservies.",
  "mission.pillar.community": "Communauté",
  "mission.pillar.community.desc": "Construction d'infrastructures, accès à l'eau potable et soutien à la réinstallation des réfugiés au Canada.",
  "mission.pillar.sustainability": "Durabilité",
  "mission.pillar.sustainability.desc": "Autonomisation des leaders locaux pour créer un changement durable et autosuffisant.",

  // Projects Preview
  "projects.tag": "Initiatives actives",
  "projects.title": "Nos projets actuels",
  "projects.subtitle": "Chaque projet est soigneusement conçu pour créer un impact durable dans les communautés afghanes.",
  "projects.viewAll": "Voir tous les projets",
  "projects.learnMore": "En savoir plus",
  "projects.raised": "Collecté",
  "projects.completed": "Terminé",

  // Impact
  "impact.tag": "Notre Impact",
  "impact.title": "Un changement réel, des chiffres réels",
  "impact.subtitle": "Chaque dollar donné se traduit par un impact mesurable sur le terrain. Voici ce que nous avons accompli ensemble.",
  "impact.students": "Étudiants soutenus",
  "impact.students.desc": "Filles et garçons recevant une éducation de qualité grâce à nos programmes de bourses.",
  "impact.water": "Personnes avec eau potable",
  "impact.water.desc": "Familles en Afghanistan rural ayant maintenant accès à de l'eau potable sûre.",
  "impact.medical": "Consultations médicales",
  "impact.medical.desc": "Soins de santé gratuits fournis via notre programme de cliniques mobiles depuis 2018.",
  "impact.families": "Familles réinstallées",
  "impact.families.desc": "Familles de réfugiés afghans soutenues dans leur nouvelle vie au Canada.",

  // Volunteer Preview
  "volunteer.tag": "S'impliquer",
  "volunteer.title": "Rejoignez notre communauté de bâtisseurs de changement",
  "volunteer.body1": "Que vous soyez médecin, traducteur, collecteur de fonds ou passionné des réseaux sociaux — il y a une place pour vous à la CAF.",
  "volunteer.body2": "Nous avons des opportunités de bénévolat pour les Canadiens et les membres de la diaspora afghane, en présentiel et à distance.",
  "volunteer.cta": "Devenir bénévole",
  "volunteer.otherWays": "Ou explorez d'autres façons d'aider",
  "volunteer.apply": "Postuler",
  "volunteer.location": "Lieu",

  // Donate Preview
  "donate.tag": "Faire la différence",
  "donate.title": "Votre don, leur avenir",
  "donate.subtitle": "100% de votre don va directement aux programmes sur le terrain. Nous sommes un organisme de bienfaisance canadien enregistré — tous les dons sont déductibles d'impôt.",
  "donate.tier.supporter": "Soutien",
  "donate.tier.champion": "Champion",
  "donate.tier.patron": "Mécène",
  "donate.mostPopular": "Le plus populaire",
  "donate.highImpact": "Fort impact",
  "donate.donate": "Donner",
  "donate.trust.charity": "Organisme de bienfaisance canadien enregistré",
  "donate.trust.transparent": "100% Transparent",
  "donate.trust.receipts": "Reçus fiscaux émis",
  "donate.trust.secure": "Traitement sécurisé",
  "donate.newsletter.title": "Restez informé de notre impact",
  "donate.newsletter.desc": "Abonnez-vous à notre newsletter pour des mises à jour mensuelles sur les projets, les histoires et les façons d'aider.",
  "donate.newsletter.placeholder": "Votre adresse e-mail",
  "donate.newsletter.button": "S'abonner",
  "donate.newsletter.subscribing": "Abonnement en cours...",
  "donate.newsletter.success": "Merci de vous être abonné ! Nous vous tiendrons informé.",
  "donate.newsletter.error": "Une erreur est survenue. Veuillez réessayer.",

  // Footer
  "footer.tagline": "Construire des ponts entre le Canada et l'Afghanistan par l'éducation, la santé et le développement communautaire.",
  "footer.charity": "Organisme de bienfaisance enregistré",
  "footer.quickLinks": "Liens rapides",
  "footer.getInvolved": "S'impliquer",
  "footer.stayConnected": "Rester connecté",
  "footer.newsletter.desc": "Recevez des mises à jour mensuelles sur notre impact et comment vous pouvez aider.",
  "footer.newsletter.placeholder": "Votre adresse e-mail",
  "footer.newsletter.success": "Merci de vous être abonné!",
  "footer.newsletter.privacy": "Nous respectons votre vie privée. Désabonnez-vous à tout moment.",
  "footer.involved.volunteer": "Opportunités de bénévolat",
  "footer.involved.partnerships": "Partenariats d'entreprise",
  "footer.involved.fundraise": "Collecte de fonds pour CAF",
  "footer.involved.reports": "Rapports annuels",
  "footer.involved.transparency": "Transparence financière",
  "footer.involved.news": "Actualités & mises à jour",
  "footer.support": "Assistance disponible en:",
  "footer.privacy": "Politique de confidentialité",
  "footer.terms": "Conditions d'utilisation",
  "footer.accessibility": "Accessibilité",
  "footer.admin": "Admin",
  "footer.copyright": "Fondation Canada Afghanistan. Tous droits réservés.",

  // Contact
  "contact.tag": "Nous contacter",
  "contact.title": "Nous serions ravis de vous entendre",
  "contact.subtitle": "Des questions sur nos programmes, vous souhaitez vous associer à nous? Contactez-nous — nous répondons en anglais, pachto, dari, français et allemand.",
  "contact.form.name": "Nom complet",
  "contact.form.email": "Adresse e-mail",
  "contact.form.subject": "Sujet",
  "contact.form.message": "Votre message",
  "contact.form.submit": "Envoyer le message",
  "contact.form.sending": "Envoi en cours...",
  "contact.form.success": "Message envoyé! Nous vous répondrons dans les 48 heures.",
  "contact.info.address": "Adresse",
  "contact.info.email": "E-mail",
  "contact.info.phone": "Téléphone",
  "contact.info.hours": "Heures de bureau",

  // ========== MISSION PAGE ==========
  "missionPage.tag": "Notre Mission",
  "missionPage.title": "Une mission ancrée dans l'espoir, portée par l'action",
  "missionPage.subtitle": "La Fondation Canada Afghanistan existe pour combler le fossé entre les Canadiens compatissants et les communautés afghanes dans le besoin.",
  "missionPage.who.tag": "Qui nous sommes",
  "missionPage.who.title": "Construire des ponts entre deux nations",
  "missionPage.who.body1": "Fondée en 2016 par des leaders communautaires afghano-canadiens, la CAF est un organisme de bienfaisance canadien enregistré dédié à l'amélioration de la vie des Afghans grâce à des programmes ciblés, transparents et percutants.",
  "missionPage.who.body2": "Nous croyons que la géographie et les conflits ne devraient jamais déterminer l'accès d'un enfant à l'éducation, l'accès d'une famille à l'eau potable ou la capacité d'une communauté à prospérer.",
  "missionPage.who.body3": "Avec un réseau de plus de 340 bénévoles dévoués à travers le Canada et l'Afghanistan, et des partenariats avec des ONG afghanes locales, nous veillons à ce que chaque dollar parvienne à ceux qui en ont le plus besoin.",
  "missionPage.who.ctaProjects": "Voir nos projets",
  "missionPage.who.ctaSupport": "Nous soutenir",
  "missionPage.who.yearsBadge": "Années d'impact",
  "missionPage.values.tag": "Ce qui nous guide",
  "missionPage.values.title": "Nos valeurs fondamentales",
  "missionPage.values.compassion": "Compassion",
  "missionPage.values.compassionDesc": "Nous agissons avec empathie et attention envers chaque personne que nous servons, sans distinction d'origine ou de circonstances.",
  "missionPage.values.integrity": "Intégrité",
  "missionPage.values.integrityDesc": "Nous opérons avec une transparence financière totale et une responsabilité envers nos donateurs et les communautés que nous servons.",
  "missionPage.values.collaboration": "Collaboration",
  "missionPage.values.collaborationDesc": "Nous collaborons avec des organisations afghanes locales, des institutions canadiennes et des ONG mondiales pour maximiser l'impact.",
  "missionPage.values.sustainability": "Durabilité",
  "missionPage.values.sustainabilityDesc": "Nous concevons des programmes qui permettent aux communautés de devenir autosuffisantes et résilientes au fil du temps.",
  "missionPage.values.equity": "Équité",
  "missionPage.values.equityDesc": "Nous priorisons les plus vulnérables — femmes, enfants et familles déplacées — dans tous nos programmes.",
  "missionPage.values.innovation": "Innovation",
  "missionPage.values.innovationDesc": "Nous recherchons continuellement des solutions créatives et fondées sur des preuves aux défis humanitaires complexes.",
  "missionPage.timeline.tag": "Notre parcours",
  "missionPage.timeline.title": "8 ans d'impact",
  "missionPage.timeline.2016": "CAF fondée à Ottawa par des leaders communautaires afghano-canadiens",
  "missionPage.timeline.2017": "Premier programme de bourses pour l'éducation des filles lancé à Kaboul",
  "missionPage.timeline.2018": "Programme de cliniques mobiles déployé dans la province de Nangarhar",
  "missionPage.timeline.2019": "Initiative d'eau potable atteint 5 000 familles à Helmand",
  "missionPage.timeline.2020": "Aide d'urgence COVID-19 — distribution d'EPI et de nourriture à 3 000 familles",
  "missionPage.timeline.2021": "Programme de réinstallation des réfugiés lancé à Toronto et Ottawa",
  "missionPage.timeline.2022": "Centres de formation professionnelle ouverts à Hérat et Mazar-i-Sharif",
  "missionPage.timeline.2023": "Expansion à 15 projets actifs dans 8 provinces afghanes",
  "missionPage.timeline.2024": "Plus de 2 500 étudiants soutenus ; plus de 18 000 personnes avec accès à l'eau potable",
  "missionPage.cta.title": "Faites partie de la mission",
  "missionPage.cta.subtitle": "Que vous fassiez un don, du bénévolat ou simplement que vous passiez le mot — vous faites partie du changement.",
  "missionPage.cta.donate": "Faire un don",
  "missionPage.cta.volunteer": "Devenir bénévole",

  // ========== PROJECTS PAGE ==========
  "projectsPage.tag": "Ce que nous faisons",
  "projectsPage.title": "Nos projets",
  "projectsPage.subtitle": "Des salles de classe à Kaboul aux puits d'eau à Helmand — chaque projet est un pas vers un Afghanistan meilleur.",
  "projectsPage.filters.all": "Tous",
  "projectsPage.filters.education": "Éducation",
  "projectsPage.filters.healthcare": "Santé",
  "projectsPage.filters.infrastructure": "Infrastructure",
  "projectsPage.filters.community": "Communauté",
  "projectsPage.filters.humanitarian": "Humanitaire",
  "projectsPage.status.all": "Tous",
  "projectsPage.status.active": "Actif",
  "projectsPage.status.completed": "Terminé",
  "projectsPage.empty": "Aucun projet trouvé pour ce filtre.",
  "projectsPage.details": "Détails",
  "projectsPage.raised": "Collecté",
  "projectsPage.progress": "Progrès",
  "projectsPage.beneficiaries": "bénéficiaires",
  "projectsPage.badge.completed": "Terminé",

  // ========== PROJECT DETAIL PAGE ==========
  "projectDetail.home": "Accueil",
  "projectDetail.projects": "Projets",
  "projectDetail.notFound": "Projet introuvable",
  "projectDetail.notFound.back": "Retour aux projets",
  "projectDetail.funding.title": "Progrès du financement",
  "projectDetail.funding.raised": "collecté sur",
  "projectDetail.funding.goal": "objectif",
  "projectDetail.funding.complete": "Terminé",
  "projectDetail.funding.funded": "financé",
  "projectDetail.funding.cta": "Faire un don à ce projet",
  "projectDetail.details.title": "Détails du projet",
  "projectDetail.details.category": "Catégorie",
  "projectDetail.details.location": "Lieu",
  "projectDetail.details.beneficiaries": "Bénéficiaires",
  "projectDetail.details.status": "Statut",
  "projectDetail.details.statusActive": "Actif",
  "projectDetail.details.statusCompleted": "Terminé",
  "projectDetail.body1": "Cette initiative fait partie de l'engagement plus large de la CAF à créer un développement durable et communautaire en Afghanistan.",
  "projectDetail.body2": "Tous les fonds collectés vont directement à la réalisation des programmes. La CAF maintient une transparence financière totale.",
  "projectDetail.back": "Retour à tous les projets",
  "projectDetail.beneficiariesSuffix": "bénéficiaires",

  // ========== VOLUNTEER PAGE ==========
  "volunteerPage.tag": "Bénévolat avec la CAF",
  "volunteerPage.title": "Vos compétences peuvent changer des vies",
  "volunteerPage.subtitle": "Rejoignez notre réseau mondial de bénévoles dévoués qui font une différence pour les communautés afghanes.",
  "volunteerPage.positions.tag": "Postes ouverts",
  "volunteerPage.positions.title": "Opportunités de bénévolat actuelles",
  "volunteerPage.stories.tag": "Histoires de bénévoles",
  "volunteerPage.stories.title": "Écoutez nos bénévoles",
  "volunteerPage.apply.title": "Postuler comme bénévole",
  "volunteerPage.apply.submitted": "Candidature soumise !",
  "volunteerPage.apply.submittedDesc": "Merci de votre intérêt. Notre équipe vous contactera dans les 3 à 5 jours ouvrables.",
  "volunteerPage.apply.close": "Fermer",
  "volunteerPage.form.name": "Nom complet *",
  "volunteerPage.form.namePlaceholder": "Votre nom complet",
  "volunteerPage.form.email": "Adresse e-mail *",
  "volunteerPage.form.emailPlaceholder": "votre@email.com",
  "volunteerPage.form.message": "Pourquoi voulez-vous devenir bénévole ? *",
  "volunteerPage.form.messagePlaceholder": "Parlez-nous de votre parcours et de votre motivation...",
  "volunteerPage.form.submit": "Soumettre la candidature",
  "volunteerPage.form.submitting": "Envoi en cours...",
  "volunteerPage.spotsAvailable": "place(s) disponible(s)",
  "volunteerPage.applyNow": "Postuler maintenant",

  // ========== DONATE PAGE ==========
  "donatePage.tag": "Soutenir notre travail",
  "donatePage.title": "Créer un impact durable",
  "donatePage.subtitle": "Votre générosité finance de vrais programmes qui changent de vraies vies.",
  "donatePage.yourImpact": "Votre impact",
  "donatePage.howToDonate": "Comment faire un don",
  "donatePage.tier.friend.label": "Ami",
  "donatePage.tier.friend.impact": "Fournit des fournitures scolaires pour 2 élèves",
  "donatePage.tier.supporter.label": "Soutien",
  "donatePage.tier.supporter.impact": "Fournit des fournitures scolaires pour 5 élèves pendant un semestre",
  "donatePage.tier.advocate.label": "Défenseur",
  "donatePage.tier.advocate.impact": "Finance l'accès à l'eau potable pour une famille pendant 2 mois",
  "donatePage.tier.champion.label": "Champion",
  "donatePage.tier.champion.impact": "Finance un mois d'accès à l'eau potable pour une famille de 6",
  "donatePage.tier.benefactor.label": "Bienfaiteur",
  "donatePage.tier.benefactor.impact": "Couvre les soins médicaux de 10 patients dans notre clinique mobile",
  "donatePage.tier.patron.label": "Mécène",
  "donatePage.tier.patron.impact": "Finance une année complète de scolarité secondaire pour une fille",
  "donatePage.custom.label": "Montant personnalisé (CAD)",
  "donatePage.custom.placeholder": "Entrez le montant",
  "donatePage.custom.note": "Pour les dons personnalisés, veuillez nous contacter directement pour organiser le paiement.",
  "donatePage.custom.contact": "Contactez-nous",
  "donatePage.bank.title": "Virement bancaire",
  "donatePage.bank.desc": "Transférez directement sur notre compte bancaire canadien :",
  "donatePage.bank.name": "Fondation Canada Afghanistan",
  "donatePage.bank.bank": "Banque",
  "donatePage.bank.bankName": "Banque Royale du Canada (RBC)",
  "donatePage.bank.accountName": "Nom du compte",
  "donatePage.bank.accountNum": "N° de compte",
  "donatePage.bank.transit": "N° de transit",
  "donatePage.bank.institution": "N° d'institution",
  "donatePage.bank.warning": "Important : Veuillez inclure votre nom complet et votre e-mail dans les notes de transfert afin que nous puissions émettre votre reçu fiscal.",
  "donatePage.cheque.title": "Chèque",
  "donatePage.cheque.desc": "Postez un chèque à l'ordre de :",
  "donatePage.cheque.warning": "Veuillez écrire votre adresse e-mail au dos du chèque pour recevoir votre reçu fiscal.",
  "donatePage.inperson.title": "En personne",
  "donatePage.inperson.desc": "Visitez notre bureau pendant les heures d'ouverture :",
  "donatePage.inperson.note": "Nous acceptons les espèces, chèques et cartes de débit/crédit en personne.",
  "donatePage.tax.title": "Reçus fiscaux",
  "donatePage.tax.desc": "La CAF est un organisme de bienfaisance canadien enregistré. Tous les dons de plus de 20 $ CAD sont admissibles à un reçu fiscal, émis dans les 30 jours suivant votre don.",
  "donatePage.trust.charity": "Organisme de bienfaisance enregistré",
  "donatePage.trust.transparent": "100% Transparent",
  "donatePage.trust.secure": "Sécurisé",
  "donatePage.trust.programs": "100% aux programmes",
  "donatePage.bottom.title": "Questions sur les dons ?",
  "donatePage.bottom.subtitle": "Notre équipe est heureuse de vous aider à faire le don le plus impactant possible.",
  "donatePage.bottom.contact": "Contacter notre équipe",

  // ========== CONTACT PAGE ==========
  "contactPage.tag": "Nous contacter",
  "contactPage.title": "Contact & Support",
  "contactPage.subtitle": "Une question, un partenariat ou besoin d'aide ? Nous sommes là pour vous — en anglais, pachto et dari.",
  "contactPage.form.title": "Envoyez-nous un message",
  "contactPage.form.submitted": "Message envoyé !",
  "contactPage.form.submittedDesc": "Merci de nous avoir contactés. Notre équipe répondra dans les 2 à 3 jours ouvrables.",
  "contactPage.form.another": "Envoyer un autre message",
  "contactPage.form.name": "Nom complet *",
  "contactPage.form.namePlaceholder": "Votre nom complet",
  "contactPage.form.email": "Adresse e-mail *",
  "contactPage.form.emailPlaceholder": "votre@email.com",
  "contactPage.form.phone": "Numéro de téléphone",
  "contactPage.form.phonePlaceholder": "+1 (613) 555-0000",
  "contactPage.form.subject": "Sujet *",
  "contactPage.form.subjectPlaceholder": "Sélectionnez un sujet",
  "contactPage.form.subjectOptions.general": "Demande générale",
  "contactPage.form.subjectOptions.donation": "Question sur les dons",
  "contactPage.form.subjectOptions.volunteer": "Candidature bénévole",
  "contactPage.form.subjectOptions.partnership": "Proposition de partenariat",
  "contactPage.form.subjectOptions.media": "Médias & Presse",
  "contactPage.form.subjectOptions.tech": "Support technique",
  "contactPage.form.subjectOptions.other": "Autre",
  "contactPage.form.message": "Message *",
  "contactPage.form.messagePlaceholder": "Comment pouvons-nous vous aider ?",
  "contactPage.form.submit": "Envoyer le message",
  "contactPage.form.sending": "Envoi en cours...",
  "contactPage.form.error": "Une erreur est survenue. Veuillez réessayer ou nous envoyer un e-mail directement.",
  "contactPage.form.charLimit": "Le message doit contenir 500 caractères ou moins.",
  "contactPage.form.privacy": "Nous respectons votre vie privée. Vos informations ne seront jamais partagées avec des tiers.",
  "contactPage.office.title": "Notre bureau",
  "contactPage.office.address": "Adresse",
  "contactPage.office.addressValue": "123 rue Rideau, Bureau 400\nOttawa, Ontario K1N 5Y1, Canada",
  "contactPage.office.hours": "Heures d'ouverture",
  "contactPage.office.hoursValue": "Lun – Ven : 9h00 – 17h00 HNE",
  "contactPage.office.phone": "Téléphone",
  "contactPage.office.email": "E-mail",
  "contactPage.map.directions": "Obtenir l'itinéraire",
  "contactPage.lang.title": "Support multilingue",
  "contactPage.lang.desc": "Nous offrons un support en anglais, pachto et dari. Veuillez indiquer votre langue préférée dans votre message.",

  // ========== STORIES PAGE ==========
  "storiesPage.tag": "Nos histoires",
  "storiesPage.title": "Histoires d'impact et d'espoir",
  "storiesPage.subtitle": "Lisez des récits de première main du terrain, rencontrez les personnes derrière notre mission et restez informé des dernières nouvelles de la CAF.",
  "storiesPage.filters.all": "Toutes",
  "storiesPage.filters.fieldStories": "Histoires du terrain",
  "storiesPage.filters.impactReports": "Rapports d'impact",
  "storiesPage.filters.volunteerVoices": "Voix des bénévoles",
  "storiesPage.filters.news": "Actualités",
  "storiesPage.empty": "Aucune histoire trouvée pour cette catégorie.",
  "storiesPage.readMore": "Lire la suite",
  "storiesPage.backToStories": "Retour à toutes les histoires",
  "storiesPage.by": "par",
  "storiesPage.published": "Publié",

  // Stories Preview (Home)
  "storiesPreview.tag": "Du terrain",
  "storiesPreview.title": "Histoires d'impact et d'espoir",
  "storiesPreview.subtitle": "Des histoires réelles des communautés que nous servons — racontées par les personnes qui vivent le changement chaque jour.",
  "storiesPreview.viewAll": "Lire toutes les histoires",

  // Photo Slider (Home)
  "photoSlider.tag": "Sur le terrain",
  "photoSlider.title": "Notre travail en images",
  "photoSlider.subtitle": "Voyez l'impact de votre soutien — des moments réels de nos projets en Afghanistan et au Canada.",

  // Common
  "common.loading": "Chargement...",
  "common.retry": "Réessayer",

  // Error / Empty states
  "storiesPage.errorTitle": "Échec du chargement des histoires",
  "storiesPage.retry": "Réessayer",
  "storiesPage.emptyTitle": "Aucune histoire pour le moment",
  "storiesPage.emptySubtitle": "Revenez bientôt pour les mises à jour du terrain.",
  "photoSlider.errorTitle": "Échec du chargement des photos",
  "photoSlider.empty": "Aucune photo disponible. Ajoutez des photos dans le tableau de bord admin.",
  "projectsPage.errorTitle": "Échec du chargement des projets",
  "projectsPage.emptyTitle": "Aucun projet pour le moment",
  "projectsPage.emptySubtitle": "Les nouveaux projets apparaîtront ici une fois ajoutés.",
  "volunteerPage.errorTitle": "Échec du chargement des opportunités",
  "volunteerPage.emptyTitle": "Aucune opportunité de bénévolat",
  "volunteerPage.emptySubtitle": "Revenez bientôt pour les nouvelles ouvertures.",
};

export default translations;